import { render, staticRenderFns } from "./VehicleRequestOrganisationCount.vue?vue&type=template&id=0ba665d0&"
import script from "./VehicleRequestOrganisationCount.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestOrganisationCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports